import { Route } from "react-router-dom"
import DriverSalaryV3 from "./DriverSalaryV3/DriverSalaryV3"
import DriverAdvancePayV3 from "./DriverAdvancePayV3/DriverAdvancePayV3"
import DriverTripPaymentV3 from "./DriverTripPaymentV3/DriverTripPaymentV3"
import ShippingProcess from "./ShippingProcess/ShippingProcess"
import PackingListConfirm from "./PackingListConfirm/PackingListConfirm"
import FinancialReport from "./FinanceReport/FinanceReport"
import EECReport from "./EECReport/EECReport"
import CSmile from "./CSmile/CSmile"

export const branchApiNm = {
  getJobOrderAllDetail: "/branch/getJobOrderAllDetail"
}
export const extraPageName = {
  DriverTripPaymentV3: "ค่าเที่ยว พนักงานขับรถ",
  DriverSalaryV3: "เงินเดือนพนักงานขับรถ",
  DriverAdvancePayV3: "เงินเบิกล่วงหน้า",
  ShippingProcess: "Shipping Process",
  FinancialReportEEC: "รายงานการเงิน",
  EECReport: "รายงาน สรุป EEC",
  CSmile: "CSmile",
}
export const extraPageMenu = [
  // { page: "ShippingProcess", num: "8.1", menuName: extraPageName.ShippingProcess, prNum: 8 },
  { page: "DriverTripPaymentV3", num: "8.2", menuName: extraPageName.DriverTripPaymentV3, prNum: 8},
  { page: "DriverAdvancePayV3", num: "8.3", menuName: extraPageName.DriverAdvancePayV3, prNum: 8},
  { page: "DriverSalaryV3", num: "8.4", menuName: extraPageName.DriverSalaryV3, prNum: 8},
  { page: "FinancialReportEEC", num: "8.5", menuName: extraPageName.FinancialReportEEC, prNum: 8, permission: "EXE;FIN"},
  { page: "EECReport", num: "8.6", menuName: extraPageName.EECReport, prNum: 8},
  { page: "CSmile", num: "8.7", menuName: extraPageName.CSmile, prNum: 8, permission: "EXE;FIN" }
]

export const extraRoute = (path)=> [
  
  <Route key={"ShippingProcess"} path={`${path}/ShippingProcess`} ><ShippingProcess /> </Route>,
  <Route key={"DriverTripPaymentV3"} path={`${path}/DriverTripPaymentV3`} ><DriverTripPaymentV3 /> </Route>,
  <Route key={"DriverAdvancePayV3"} path={`${path}/DriverAdvancePayV3`} ><DriverAdvancePayV3 /> </Route>,
  <Route key={"DriverSalaryV3"} path={`${path}/DriverSalaryV3`} ><DriverSalaryV3 /> </Route>,
  <Route key={"FinancialReportEEC"} path={`${path}/FinancialReportEEC`} ><FinancialReport /> </Route>,
  <Route key={"EECReport"} path={`${path}/EECReport`} ><EECReport /> </Route>,
  <Route key={"CSmile"} path={`${path}/CSmile`} ><CSmile /> </Route>

]
export const extraMainRoute =  [
  <Route key="shipping" path={`/public/PackingListConfirm/:shpInvId/:token`} ><PackingListConfirm /> </Route>
]
